import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { MediaRecording } from 'src/app/models/media-recording.model';

@Pipe({
  name: 'mediaRecordingTranscriptionInFlight',
  standalone: true,
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class MediaRecordingTranscriptionInFlightPipe implements PipeTransform {
  transform(recording: MediaRecording | null | undefined): boolean {
    if (recording === null || recording === undefined) {
      return false;
    }

    return this.isMediaRecordingTranscriptionInFlight(recording);
  }

  private isMediaRecordingTranscriptionInFlight(recording: MediaRecording): boolean {
    return (
      recording.recording_status === 'completed' &&
      (recording.transcription_status === 'pending' || recording.transcription_status === 'processing')
    );
  }
}
